"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHierarchyIds = exports.useClosestHierarchyId = exports.HierarchicalContextProvider = exports.parseIdField = void 0;
var react_1 = __importStar(require("react"));
var useElementAnalytics_1 = require("../hooks/useElementAnalytics");
var useWebAnalytics_1 = require("../hooks/useWebAnalytics");
var env_1 = require("../utils/env");
var parseIdField = function (context) {
    var action_element_name = context.action_element_name, element_data = context.element_data, element_version = context.element_version, hierarchyContextFields = __rest(context, ["action_element_name", "element_data", "element_version"]);
    var hierarchyContextIds = {
        action_element_name: action_element_name !== null && action_element_name !== void 0 ? action_element_name : 'unknown',
        element_data: element_data !== null && element_data !== void 0 ? element_data : 'unknown',
        element_version: element_version !== null && element_version !== void 0 ? element_version : 0,
    };
    return {
        ids: hierarchyContextIds,
        fields: hierarchyContextFields,
    };
};
exports.parseIdField = parseIdField;
var ClosestHierarchyId = (0, react_1.createContext)(undefined);
var HierarchyIds = (0, react_1.createContext)(undefined);
var HierarchicalContextProvider = function (_a) {
    var context = _a.context, children = _a.children;
    var _b = (0, exports.parseIdField)(context), ids = _b.ids, fields = _b.fields;
    var generateUUID = (0, react_1.useMemo)(useElementAnalytics_1.generateUUIDHof, []);
    var webAnalytics = (0, useWebAnalytics_1.useWebAnalytics)();
    var previousHierarchyIds = (0, exports.useHierarchyIds)();
    var currentHierarchyContextId = (0, react_1.useMemo)(function () {
        var uniqueId = generateUUID();
        return "".concat(ids.action_element_name, "-").concat(uniqueId);
    }, [ids.action_element_name]);
    var hierarchyIds = previousHierarchyIds ? [currentHierarchyContextId, previousHierarchyIds].join('|') : currentHierarchyContextId;
    (0, react_1.useEffect)(function () {
        if (webAnalytics) {
            webAnalytics.observeElement([], ids, fields, {
                hierarchyContextId: currentHierarchyContextId,
                hierarchyIds: hierarchyIds,
            });
        }
        else {
            var errorMessage = "Cannot set hierarchy context for ".concat(JSON.stringify(ids, null, 2), ". Please ensure the component is wrapped with WebAnalyticsProvider and the webAnalytics is NOT undefined.");
            if ((0, env_1.isProduction)()) {
                console.error(errorMessage);
            }
            else {
                throw new Error(errorMessage);
            }
        }
    }, [context, previousHierarchyIds]);
    return react_1.default.createElement(HierarchyIds.Provider, { value: hierarchyIds },
        react_1.default.createElement(ClosestHierarchyId.Provider, { value: currentHierarchyContextId }, children));
};
exports.HierarchicalContextProvider = HierarchicalContextProvider;
/**
 * This hook return the closest hierarchy id from the current component to the root.
 *
 * For example, if the component is nested like this, and A and B are hierarchy context providers:
 *
 * ```jsx
 * <A>
 *   <B>
 *     <Component />
 *   </B>
 * </A>
 * ```
 * The hook will return the hierarchy id of B.
 *
 * @returns {string} hierarchy id
 */
var useClosestHierarchyId = function () {
    return (0, react_1.useContext)(ClosestHierarchyId);
};
exports.useClosestHierarchyId = useClosestHierarchyId;
/**
 * This hook return all hierarchy ids from the current component to the root.
 *
 * For example, if the component is nested like this, and A and B are hierarchy context providers:
 *
 * ```jsx
 * <A>
 *   <B>
 *     <Component />
 *   </B>
 * </A>
 * ```
 * The hook will return the hierarchy ids of A and B separated by '|'. Order from bottom to top (B|A).
 * @returns {string} hierarchy ids separated by '|'
 */
var useHierarchyIds = function () {
    return (0, react_1.useContext)(HierarchyIds);
};
exports.useHierarchyIds = useHierarchyIds;
